import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Connect, PropsFromRedux } from './DesktopTypeItemCountContainer';
import styles from './desktop_type_item_count.module.scss';

type Props = PropsFromRedux;

export const RawDesktopTypeItemCount: FC<Props> = ({
  count,
  countOverride,
  showCount,
}) => {
  if (!showCount || count === -1) {
    return null;
  }
  return (
    <span className={styles.count}>
      {count}{' '}
      {countOverride && (
        <span className={styles.plus}>
          <FormattedMessage id="search/components/aside-filters/desktop-type/DesktopTypeItemCount.tsx/1" />
        </span>
      )}
    </span>
  );
};

export const DesktopTypeItemCount = Connect(RawDesktopTypeItemCount);
